export default __webpack_public_path__ + "static/media/pause.99061a58.svg";